import React, { FC } from 'react';
import { useFirebase } from '../providers/FirebaseProvider';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../providers/ProfileProvider';

export const Navbar: FC = () => {
    const { isUserSignedIn, signOut } = useFirebase();
    const navigate = useNavigate();

    return (
        <nav className="mb-10 w-full max-w-5xl bg-gradient-to-r from-indigo-50 to-white bg-opacity-30 backdrop-filter backdrop-blur-lg shadow-md border border-gray-500 rounded-2xl mx-auto mt-4">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-12">
                    <div className="flex-shrink-0">
                        <div className="text-xl font-bold text-gray-800">ECG Notes</div>
                    </div>
                    <div className="flex-grow"></div>
                    <div className="flex-shrink-0">
                        {
                            isUserSignedIn() ? (
                                <LoggedInInfoComponent signOutClicked={() => signOut()}/>
                            ) : (
                                <button 
                                    className="px-4 py-2 text-sm font-medium text-indigo-800 bg-indigo-50 bg-opacity-30 border border-gray-300 rounded-lg shadow-md hover:bg-opacity-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                                    onClick={() => navigate('/auth')}>
                                    Sign In
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>
        </nav>
    );
};

const LoggedInInfoComponent = ({ signOutClicked }: { signOutClicked: () => void }) => {
    const { user } = useFirebase();
    const { profile } = useProfile();

    const displayName = profile?.name || user?.email;
    const institution = profile?.institution;

    return (
        <div className="flex items-center space-x-4">
            <div className="text-sm text-gray-600">
                {displayName}
                <br/>
                <small className='text-indigo-800'>{institution}</small>
            </div>
            <button 
                className="px-4 py-2 text-sm font-medium text-indigo-800 bg-indigo-50 bg-opacity-30 border border-gray-300 rounded-lg shadow-md hover:bg-opacity-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                onClick={() => signOutClicked()}>
                Sign Out
            </button>
        </div>
    );
}